const Languages = [
  { id: 1, value: "en", label: "English", native: "English" },
  { id: 2, value: "zh", label: "Mandarin Chinese", native: "普通话" },
  { id: 3, value: "hi", label: "Hindi", native: "हिन्दी" },
  { id: 4, value: "es", label: "Spanish", native: "Español" },
  { id: 5, value: "fr", label: "French", native: "Français" },
  { id: 6, value: "ar", label: "Arabic", native: "العربية" },
  { id: 7, value: "bn", label: "Bengali", native: "বাংলা" },
  { id: 8, value: "ru", label: "Russian", native: "Русский" },
  { id: 9, value: "pt", label: "Portuguese", native: "Português" },
  { id: 10, value: "id", label: "Indonesian", native: "Bahasa Indonesia" },
  { id: 11, value: "ur", label: "Urdu", native: "اردو" },
  { id: 12, value: "de", label: "German", native: "Deutsch" },
  { id: 13, value: "ja", label: "Japanese", native: "日本語" },
  { id: 14, value: "sw", label: "Swahili", native: "Kiswahili" },
  { id: 15, value: "mr", label: "Marathi", native: "मराठी" },
  { id: 16, value: "te", label: "Telugu", native: "తెలుగు" },
  { id: 17, value: "tr", label: "Turkish", native: "Türkçe" },
  { id: 18, value: "ko", label: "Korean", native: "한국어" },
  { id: 19, value: "ta", label: "Tamil", native: "தமிழ்" },
  { id: 20, value: "vi", label: "Vietnamese", native: "Tiếng Việt" },
];

export default Languages;
